/**
 * Standard welcome message texts
 *
 * Notes:
 * - Each of these is expected-not-required to match a route from `./routes.js`.
 * - To customize message text (example: dynamic content) use `<Section>` props.
 */
export const DASHBOARD =
  'This page allows you to monitor your job status, get help with tickets, and view the status of the High Performance Computing (HPC) systems.';
export const DATA = 'This page allows you to upload and manage your files.';
export const ALLOCATIONS =
  'This page allows you to monitor the status of allocations on the HPC systems and view a breakdown of team usage.';
export const APPLICATIONS =
  'This page allows you to submit jobs to the HPC systems or access Cloud services using a variety of applications.';
export const HISTORY =
  'This page allows you to monitor a log of all previous job submissions.';
export const ACCOUNT =
  'This page allows you to manage your account profile, change your password and view software licenses.';
export const TICKETS =
  'This page allows you to submit a help request via an RT Ticket.';
export const UI =
  'This hidden page allows developers to review UI components in isolation.';
